import { render, staticRenderFns } from "./DrugFilter.vue?vue&type=template&id=3cf0d632&"
import script from "./DrugFilter.vue?vue&type=script&lang=js&"
export * from "./DrugFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports